import { useState } from "react";
import { CalendarDays, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { PRESETS } from "@/lib/period";
import { usePeriod } from "@/PeriodContext";

export default function DateRangeBar() {
  const { state, period, setPreset, patch } = usePeriod();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="mpd-period-btn" aria-label="Select period">
          <CalendarDays size={16} />
          <span>{period.label}</span>
          <ChevronDown size={14} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="mpd-period-pop">
        <p className="mpd-kicker">Period</p>
        <div className="mpd-chips" role="tablist" aria-label="Date range">
          {PRESETS.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`mpd-chip ${state.preset === item.id ? "is-on" : ""}`}
              onClick={() => {
                setPreset(item.id);
                if (item.id !== "month" && item.id !== "day" && item.id !== "custom") setOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
        {state.preset === "month" ? (
          <label className="mpd-extra">
            Month
            <input
              type="month"
              value={state.month}
              onChange={(e) => patch({ preset: "month", month: e.target.value })}
            />
          </label>
        ) : null}
        {state.preset === "day" ? (
          <label className="mpd-extra">
            Day
            <input
              type="date"
              value={state.day}
              onChange={(e) => patch({ preset: "day", day: e.target.value })}
            />
          </label>
        ) : null}
        {state.preset === "custom" ? (
          <div className="mpd-extra-row">
            <label className="mpd-extra">
              From
              <input
                type="date"
                value={state.from}
                onChange={(e) => patch({ preset: "custom", from: e.target.value })}
              />
            </label>
            <label className="mpd-extra">
              To
              <input
                type="date"
                value={state.to}
                onChange={(e) => patch({ preset: "custom", to: e.target.value })}
              />
            </label>
          </div>
        ) : null}
      </PopoverContent>
    </Popover>
  );
}
